import {SortColumnHeader} from "../../../components/sort-column-header/sort-column-header";
import {SortOrder} from "../../../../models/dynamic-filter/dynamic-filter-sort.model";

export const FILTER_OPTIONS_HEADER_COLUMNS: SortColumnHeader[] = [
  {
    uid: "name",
    columnField: "name",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.NAME",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "name",
    gridAreaColumnDimension: "1.5fr",
    visible: true,
    selected: true,
    cssClass: ""
  },
  {
    uid: "dataFieldType",
    columnField: "dataFieldType",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.DATA_FIELD_TYPE",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "dataFieldType",
    gridAreaColumnDimension: "1fr",
    visible: true,
    selected: true,
    cssClass: ""
  },
  {
    uid: "origin",
    columnField: "origin",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.ORIGIN",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "origin",
    gridAreaColumnDimension: "minmax(10em, 1fr)",
    visible: true,
    selected: true,
    cssClass: ""
  },
  {
    uid: "additionalInformation",
    columnField: "additionalInformation",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.ADDITIONAL_INFORMATION",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "additionalInformation",
    gridAreaColumnDimension: "minmax(10em, 1fr)",
    visible: true,
    selected: true,
    cssClass: ""
  },
  {
    uid: "assignment",
    columnField: "assignment",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.ASSIGNMENT",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "assignment",
    gridAreaColumnDimension: "minmax(6em, .5fr)",
    visible: true,
    selected: true,
    cssClass: ""
  },
  {
    uid: "fromToField",
    columnField: "fromToField",
    columnText: "DESIGN_B.ADMIN_PAGE.FILTER_OPTIONS.COLUMNS.FROM_TO_FIELD",
    disabledSort: true,
    order: SortOrder.ASC,
    gridArea: "fromToField",
    gridAreaColumnDimension: "minmax(6em, .75fr)",
    visible: true,
    selected: true,
    cssClass: ""
  },
];
